// @ts-check
import { getAll, get } from "../utilities/querySelector";
import { toggleScroll } from "../utilities/toggleScroll";

initDialogListeners();

function initDialogListeners() {
    const triggers = getAll( '[data-dialog]' );
    const closers = getAll( '[data-dialog-close]' );
    const dialogs = getAll( 'dialog.dialog' );

    triggers.forEach( trigger => {
        trigger.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            const dialogName = trigger.getAttribute( 'data-dialog' );
            const dialog = get( `dialog#${dialogName}` );
            const asModal = trigger.getAttribute( 'data-is-modal' ) ?? 'true';

            if ( !dialog ) {
                console.warn( 'No dialog with ID: ' + dialogName );
                return;
            }

            dialog.showModal();
        } );
    } );

    closers.forEach( closer => {
        closer.addEventListener( 'click', ( e ) => {
            const dialog = closer.closest( 'dialog' );
            if ( !dialog ) return console.warn( 'No dialog found' );
            dialog.close();
        } );
    } );

    dialogs.forEach( dialog => dialog.addEventListener( 'close', () => toggleScroll( true ) ) );
}


const dialogs = getAll( 'dialog' );
dialogs.forEach( dialog => {
    const buttons = getAll( 'a', dialog );

    buttons.forEach( button => {
        button.addEventListener( 'click', ( e ) => {
            dialog.close();
        } );
    } );
} );


/*
Handling cases where the attributes are not manageable,
but the dialog wants to be openable, can link directly to the enquiry form
*/
const enquireDialogOpeners = getAll( '[href="#dialog-enquiry-form"]' );
enquireDialogOpeners.forEach( button => {
    button.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        const dialog = get( '#dialog-enquiry-form' );
        if ( !dialog ) return console.warn( 'No dialog found' );
        dialog.showModal();
    } );
} );